module.exports = __webpack_public_path__ + "img/btn_done.2a281267.svg";